// Smooth anchor navigation that works with or without Lenis.
export const scrollToId = (id) => (event) => {
    event.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70, duration: 1.1 });
    } else {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
